import { useState, useRef, useCallback, useEffect } from "react";

// ─── Icons ────────────────────────────────────────────────────────────────────
const Icon = ({ name, size = 16, color = "currentColor" }) => {
  const icons = {
    plane: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21 4 19 4s-2 1-3.5 2.5L9 10 .8 8.2c-.5-.1-.7.5-.4.9L5 14l-1 4 4-1 4.6 4.6c.4.3 1-.1.9-.4z"/></svg>,
    globe: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
    map: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>,
    calendar: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
    users: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    dollar: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
    sparkle: <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/></svg>,
    plus: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
    trash: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>,
    check: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
    bag: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>,
    star: <svg width={size} height={size} viewBox="0 0 24 24" fill={color} stroke={color} strokeWidth="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
    heart: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>,
    copy: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>,
  };
  return icons[name] || null;
};

// ─── Location Picker ──────────────────────────────────────────────────────────
const LOC_MODES = [
  { id: "city",     label: "City",            emoji: "🏙️", hint: "e.g. Tokyo, Japan" },
  { id: "multi",    label: "Multi-City",       emoji: "🗺️", hint: "Add stops in order" },
  { id: "region",   label: "Region",           emoji: "🌄", hint: "e.g. Amalfi Coast, Tuscany" },
  { id: "state",    label: "State / Province", emoji: "📍", hint: "e.g. Oahu, Hawaii · Provence" },
  { id: "country",  label: "Country",          emoji: "🌍", hint: "e.g. Japan, Portugal, Peru" },
  { id: "surprise", label: "Surprise Me!",     emoji: "🎲", hint: "Tell me what you love" },
];

function LocationPicker({ onChange }) {
  const [mode, setMode] = useState("city");
  const [stops, setStops] = useState([""]);
  const [singleVal, setSingleVal] = useState("");
  const [surprisePrefs, setSurprisePrefs] = useState("");

  const onChangeRef = useRef(onChange);
  useEffect(() => { onChangeRef.current = onChange; });

  useEffect(() => {
    let resolved = "";
    if (["city", "region", "state", "country"].includes(mode)) {
      resolved = singleVal.trim();
    } else if (mode === "multi") {
      resolved = stops.filter(s => s.trim()).join(" → ");
    } else if (mode === "surprise") {
      resolved = surprisePrefs.trim()
        ? `[SURPRISE ME based on: ${surprisePrefs}]`
        : "[SURPRISE ME]";
    }
    onChangeRef.current(resolved);
  }, [mode, singleVal, stops, surprisePrefs]);

  const addStop    = () => setStops(s => [...s, ""]);
  const removeStop = (i) => setStops(s => s.filter((_, idx) => idx !== i));
  const updateStop = (i, v) => setStops(s => s.map((x, idx) => idx === i ? v : x));
  const moveStop   = (i, dir) => {
    const next = [...stops];
    const j = i + dir;
    if (j < 0 || j >= next.length) return;
    [next[i], next[j]] = [next[j], next[i]];
    setStops(next);
  };

  const currentMode = LOC_MODES.find(m => m.id === mode);

  return (
    <div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 7, marginBottom: 14 }}>
        {LOC_MODES.map(m => {
          const active = mode === m.id;
          return (
            <button key={m.id} onClick={() => setMode(m.id)} style={{
              fontFamily: "var(--font-body)", fontSize: 12, padding: "7px 13px",
              borderRadius: 50,
              border: "1.5px solid " + (active ? "var(--accent)" : "var(--border)"),
              background: active ? "var(--accent)" : "var(--chip-bg)",
              color: active ? "#fff" : "var(--muted)",
              cursor: "pointer", transition: "all .15s", fontWeight: active ? 700 : 400,
              display: "flex", alignItems: "center", gap: 5,
            }}>
              <span>{m.emoji}</span>{m.label}
            </button>
          );
        })}
      </div>

      {["city", "region", "state", "country"].includes(mode) && (
        <input
          className="txt-input"
          placeholder={currentMode.hint}
          value={singleVal}
          onChange={e => setSingleVal(e.target.value)}
          style={{ fontSize: 14, fontWeight: 500 }}
        />
      )}

      {mode === "multi" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ fontSize: 11, color: "var(--muted)", marginBottom: 2 }}>
            Add stops in the order you'll visit them.
          </div>
          {stops.map((stop, i) => (
            <div key={i} style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <div style={{
                width: 26, height: 26, borderRadius: "50%", flexShrink: 0,
                background: "var(--accent)", color: "#fff",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 11, fontWeight: 800,
              }}>{i + 1}</div>
              <input
                className="txt-input"
                placeholder={`Stop ${i + 1} — e.g. ${["Rome, Italy", "Florence", "Venice", "Milan"][i] || "Next city"}`}
                value={stop}
                onChange={e => updateStop(i, e.target.value)}
                style={{ flex: 1, fontSize: 13 }}
              />
              <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <button onClick={() => moveStop(i, -1)} disabled={i === 0} style={{
                  background: "var(--chip-bg)", border: "1.5px solid var(--border)",
                  borderRadius: 6, padding: "2px 5px", cursor: i === 0 ? "default" : "pointer",
                  opacity: i === 0 ? 0.3 : 1, lineHeight: 1, fontSize: 10,
                }}>▲</button>
                <button onClick={() => moveStop(i, 1)} disabled={i === stops.length - 1} style={{
                  background: "var(--chip-bg)", border: "1.5px solid var(--border)",
                  borderRadius: 6, padding: "2px 5px",
                  cursor: i === stops.length - 1 ? "default" : "pointer",
                  opacity: i === stops.length - 1 ? 0.3 : 1, lineHeight: 1, fontSize: 10,
                }}>▼</button>
              </div>
              {stops.length > 1 && (
                <button onClick={() => removeStop(i)} style={{
                  background: "none", border: "none", cursor: "pointer",
                  color: "var(--muted)", padding: 4, flexShrink: 0,
                }}>
                  <Icon name="trash" size={14} />
                </button>
              )}
            </div>
          ))}
          {stops.filter(s => s.trim()).length > 1 && (
            <div style={{ fontSize: 11, color: "var(--muted)", paddingLeft: 34 }}>
              Route: {stops.filter(s => s.trim()).join(" → ")}
            </div>
          )}
          <button onClick={addStop} disabled={stops.length >= 8} style={{
            alignSelf: "flex-start", display: "flex", alignItems: "center", gap: 6,
            background: "var(--accent-soft)", color: "var(--accent)",
            border: "1.5px dashed var(--accent)", borderRadius: 50, padding: "7px 16px",
            fontFamily: "var(--font-body)", fontSize: 12, fontWeight: 700, cursor: "pointer",
            opacity: stops.length >= 8 ? 0.5 : 1,
          }}>
            <Icon name="plus" size={13} color="var(--accent)" /> Add Stop
          </button>
        </div>
      )}

      {mode === "surprise" && (
        <div>
          <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 10, lineHeight: 1.65 }}>
            Tell the AI what you love — it'll recommend destinations perfectly matched to you.
          </div>
          <textarea
            className="txt-input"
            rows={3}
            placeholder="e.g. I love warm weather, walkable old towns, amazing seafood, and I've already been to Spain and Italy. Under 10 hours flight from NYC. Budget-friendly."
            value={surprisePrefs}
            onChange={e => setSurprisePrefs(e.target.value)}
            style={{ resize: "vertical" }}
          />
          <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 6 }}>
            {["🏖️ Beach + Culture", "🏔️ Mountains + Adventure", "🌆 Foodie City Break", "🏛️ History + Art", "🌿 Nature Escape", "🎉 Party + Nightlife"].map(tag => (
              <button key={tag} onClick={() => setSurprisePrefs(v => v ? v + ", " + tag.split(" ").slice(1).join(" ") : tag.split(" ").slice(1).join(" "))} style={{
                fontFamily: "var(--font-body)", fontSize: 11, padding: "5px 12px",
                borderRadius: 50, border: "1.5px solid var(--border)",
                background: "var(--chip-bg)", color: "var(--muted)",
                cursor: "pointer", transition: "all .15s",
              }}>{tag}</button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Chip / MultiSelect ───────────────────────────────────────────────────────
function ChipSelect({ options, selected, onChange, multi = true }) {
  const toggle = (v) => {
    if (multi) {
      onChange(selected.includes(v) ? selected.filter(x => x !== v) : [...selected, v]);
    } else {
      onChange(selected === v ? "" : v);
    }
  };
  const isActive = (v) => multi ? selected.includes(v) : selected === v;
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {options.map(({ label, emoji }) => {
        const active = isActive(label);
        return (
          <button key={label} onClick={() => toggle(label)} style={{
            fontFamily: "var(--font-body)", fontSize: 12, padding: "8px 14px",
            borderRadius: 50,
            border: "1.5px solid " + (active ? "var(--accent)" : "var(--border)"),
            background: active ? "var(--accent)" : "var(--chip-bg)",
            color: active ? "#fff" : "var(--muted)",
            cursor: "pointer", transition: "all .15s", fontWeight: active ? 600 : 400,
            display: "flex", alignItems: "center", gap: 6,
          }}>
            {emoji && <span>{emoji}</span>}{label}
          </button>
        );
      })}
    </div>
  );
}

// ─── Section Label ────────────────────────────────────────────────────────────
function SLabel({ icon, label }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "18px 0 10px" }}>
      <div style={{ width: 26, height: 26, borderRadius: 8, background: "var(--accent-soft)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon name={icon} size={13} color="var(--accent)" />
      </div>
      <span style={{ fontSize: 10, fontWeight: 700, color: "var(--accent)", letterSpacing: ".1em", textTransform: "uppercase" }}>{label}</span>
      <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
    </div>
  );
}

// ─── Saved Trip Card ──────────────────────────────────────────────────────────
function TripCard({ trip, onRemove, onView }) {
  return (
    <div className="card" style={{ margin: 0, padding: "16px 18px", cursor: "pointer" }} onClick={onView}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, color: "var(--text)", marginBottom: 2 }}>
            {trip.destination || "Untitled Trip"}
          </div>
          <div style={{ fontSize: 11, color: "var(--muted)", display: "flex", gap: 10, flexWrap: "wrap" }}>
            {trip.dates && <span>📅 {trip.dates}</span>}
            {trip.travelers && <span>👥 {trip.travelers}</span>}
            {trip.budget && <span>💰 {trip.budget}</span>}
          </div>
        </div>
        <button onClick={e => { e.stopPropagation(); onRemove(); }} style={{
          background: "none", border: "none", cursor: "pointer",
          padding: 4, color: "var(--muted)", borderRadius: 8, flexShrink: 0,
        }}>
          <Icon name="trash" size={14} />
        </button>
      </div>
    </div>
  );
}

// ─── Markdown-lite renderer ───────────────────────────────────────────────────
function AIResponse({ text }) {
  if (!text) return null;
  return (
    <div>
      {text.split("\n").map((line, i) => {
        if (line.startsWith("## ")) {
          return (
            <div key={i} style={{ fontSize: 14, fontWeight: 800, color: "var(--text)", margin: "18px 0 6px", fontFamily: "var(--font-display)", borderBottom: "1.5px solid var(--border)", paddingBottom: 6 }}>
              {line.replace("## ", "")}
            </div>
          );
        }
        if (line.startsWith("### ")) {
          return (
            <div key={i} style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)", margin: "12px 0 4px", textTransform: "uppercase", letterSpacing: ".07em" }}>
              {line.replace("### ", "")}
            </div>
          );
        }
        if (line.startsWith("- ") || line.startsWith("• ")) {
          return (
            <div key={i} style={{ display: "flex", gap: 8, fontSize: 13, color: "var(--text)", lineHeight: 1.65, marginBottom: 3 }}>
              <span style={{ color: "var(--accent)", fontWeight: 700, flexShrink: 0 }}>·</span>
              <span dangerouslySetInnerHTML={{ __html: line.replace(/^[-•]\s*/, "").replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") }} />
            </div>
          );
        }
        if (line.trim() === "") return <div key={i} style={{ height: 6 }} />;
        return (
          <div key={i} style={{ fontSize: 13, color: "var(--text)", lineHeight: 1.7, marginBottom: 2 }}
            dangerouslySetInnerHTML={{ __html: line.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") }} />
        );
      })}
    </div>
  );
}

// ─── Spinner ──────────────────────────────────────────────────────────────────
function Spinner() {
  return (
    <div style={{ width: 14, height: 14, border: "2px solid rgba(255,255,255,.4)", borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
export default function Travel() {
  const [destination, setDestination]   = useState("");
  const [originCountry, setOriginCountry] = useState("");
  const [dates, setDates]               = useState("");
  const [flexibility, setFlexibility]   = useState("");
  const [travelers, setTravelers]       = useState([]);
  const [budget, setBudget]             = useState("");
  const [vibe, setVibe]                 = useState([]);
  const [priorities, setPriorities]     = useState([]);
  const [mustSee, setMustSee]           = useState("");
  const [packingNeeds, setPackingNeeds] = useState([]);
  const [extraNotes, setExtraNotes]     = useState("");

  const [loading, setLoading]               = useState(false);
  const [result, setResult]                 = useState(null);
  const [error, setError]                   = useState(null);
  const [savedTrips, setSavedTrips]         = useState([]);
  const [compareResults, setCompareResults] = useState([]);
  const [compareLoading, setCompareLoading] = useState(false);
  const [activeTab, setActiveTab]           = useState("plan");
  const [copied, setCopied]                 = useState(false);

  const resultRef = useRef(null);

  const TRAVELER_OPTS = [
    { label: "Solo", emoji: "🧍" },
    { label: "Couple / Romantic", emoji: "💑" },
    { label: "Friends Group", emoji: "👯" },
    { label: "Family with Kids", emoji: "👨‍👩‍👧" },
    { label: "Work Trip", emoji: "💼" },
    { label: "Senior / 55+", emoji: "🧓" },
  ];

  const BUDGET_OPTS = [
    { label: "Budget ($)", emoji: "💵" },
    { label: "Mid-Range ($$)", emoji: "💳" },
    { label: "Comfortable ($$$)", emoji: "✈️" },
    { label: "Luxury ($$$$)", emoji: "🥂" },
  ];

  const VIBE_OPTS = [
    { label: "Beach & Sun", emoji: "🏖️" },
    { label: "City & Culture", emoji: "🏛️" },
    { label: "Nature & Hiking", emoji: "🏔️" },
    { label: "Food & Drink", emoji: "🍷" },
    { label: "Adventure", emoji: "🪂" },
    { label: "Relaxation", emoji: "🧘" },
    { label: "Nightlife", emoji: "🎉" },
    { label: "History & Art", emoji: "🎨" },
    { label: "Off the Beaten Path", emoji: "🗺️" },
    { label: "Shopping", emoji: "🛍️" },
  ];

  const PRIORITY_OPTS = [
    { label: "Walkability", emoji: "🚶" },
    { label: "Public Transit", emoji: "🚇" },
    { label: "Views", emoji: "🌅" },
    { label: "Low Crime", emoji: "🛡️" },
    { label: "Great Food Scene", emoji: "🍜" },
    { label: "Kid-Friendly", emoji: "🎡" },
    { label: "Accessibility", emoji: "♿" },
    { label: "Instagrammable", emoji: "📸" },
    { label: "Beaches Nearby", emoji: "🌊" },
    { label: "Good Weather", emoji: "☀️" },
  ];

  const PACKING_OPTS = [
    { label: "Power Converter", emoji: "🔌" },
    { label: "Walking Shoes", emoji: "👟" },
    { label: "Umbrella / Rain Gear", emoji: "☂️" },
    { label: "Sunscreen & Hat", emoji: "🧴" },
    { label: "Formal Attire", emoji: "👔" },
    { label: "Cold Weather Gear", emoji: "🧤" },
    { label: "Swimwear", emoji: "🩱" },
    { label: "Travel Insurance", emoji: "📋" },
  ];

  const FLEX_OPTS = [
    { label: "Specific Dates", emoji: "📅" },
    { label: "Weekend Trip", emoji: "🗓️" },
    { label: "Week-Long", emoji: "🏝️" },
    { label: "2+ Weeks", emoji: "✈️" },
    { label: "Flexible / Anytime", emoji: "🔄" },
  ];

  const buildPrompt = useCallback((dest) => {
    const isMulti    = dest.includes(" → ");
    const isSurprise = dest.startsWith("[SURPRISE ME");
    const destLabel  = isMulti
      ? `Multi-city trip: ${dest}`
      : isSurprise
        ? `Surprise destination (traveler preferences: ${dest.replace(/^\[SURPRISE ME(?: based on: )?(.*)\]$/, "$1") || "not specified"})`
        : dest;
    const surpriseHeader = isSurprise
      ? "\nFirst, recommend the TOP 3 destinations that match these traveler preferences. Then provide the full travel guide for your #1 recommendation.\n"
      : "";
    const multiHeader = isMulti
      ? "\nThis is a multi-city itinerary. For each stop provide focused advice, then close with a combined logistics section (travel between stops, total budget, packing).\n"
      : "";

    return `You are an expert travel advisor. Create a comprehensive, practical travel guide for the following trip:
${surpriseHeader}${multiHeader}
**Destination:** ${destLabel}
**Travelling From:** ${originCountry || "Not specified"}
**Travel Dates/Flexibility:** ${dates || flexibility || "Flexible"}
**Traveler Type:** ${travelers.join(", ") || "Not specified"}
**Budget Level:** ${budget || "Mid-range"}
**Travel Vibe:** ${vibe.join(", ") || "General sightseeing"}
**Top Priorities:** ${priorities.join(", ") || "General experience"}
**Must-See/Do:** ${mustSee || "No specific requests"}
**Packing Reminders Needed:** ${packingNeeds.join(", ") || "Standard"}
**Additional Notes:** ${extraNotes || "None"}

Please structure your response with these sections:

## Overview & Vibe
Brief destination character and what to expect.

## Walkability & Getting Around
Walk score assessment, best walkable neighborhoods, public transit options, preferred transportation modes, apps to download.

## Major Sites & Distances
Top 6-8 attractions with estimated distance from city center and time needed.

## Safety & Crime
General safety assessment, areas to avoid, safety tips for this traveler type.

## Where to Stay
3 neighborhood recommendations for this budget and traveler type, with pros/cons.

## Food & Drink
5-6 must-try dishes/drinks, best neighborhoods to eat, one splurge and one budget pick.

## Things to Do
Top experiences matched to the stated vibe and traveler type. Include free options.

## What to Book Ahead
Transportation, tickets, reservations that sell out — with lead times and booking guidance.

## Packing List Additions
Specific to this destination's climate/culture.

## Weather & Best Timing
Current season conditions, what to expect, ideal packing for the weather.

## Recommended Excursions
3-4 day trips or excursions with duration, cost estimate, and how to book.

## Passport, Visa & Entry Requirements
${originCountry ? `Specific to travellers from ${originCountry}: visa requirements, visa-on-arrival eligibility, e-visa options, passport validity requirements, and any entry restrictions. Include typical processing times and costs.` : "Visa and entry requirements — note that requirements vary by passport. Please verify with your country's embassy or a visa service before booking."}

## Price Range Summary
Estimated daily spend breakdown (accommodation, food, activities, transport) for the ${budget || "mid-range"} budget.

Keep advice practical and specific. Use bullet points within sections.`;
  }, [dates, flexibility, travelers, budget, vibe, priorities, mustSee, packingNeeds, extraNotes, originCountry]);

  const handleSearch = async () => {
    if (!destination.trim()) return;
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const response = await fetch("/api/claude", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "analysis",
          body: {
            model: "claude-sonnet-4-5",
            max_tokens: 2000,
            messages: [{ role: "user", content: buildPrompt(destination) }],
          },
        }),
      });
      const data = await response.json();
      const text = data.content?.map(b => b.text || "").join("") || "";
      setResult(text);
      setTimeout(() => resultRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
    } catch (e) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveTrip = () => {
    setSavedTrips(prev => [{
      id: Date.now(),
      destination,
      dates: dates || flexibility,
      travelers: travelers.join(", "),
      budget,
      vibe: vibe.join(", "),
      result,
    }, ...prev]);
  };

  const handleCompare = async () => {
    const dests = destination.includes(" → ")
      ? destination.split(" → ").map(d => d.trim()).filter(Boolean)
      : destination.split(",").map(d => d.trim()).filter(Boolean);
    if (dests.length < 2) {
      setError("Add at least 2 stops using Multi-City mode, or enter destinations separated by commas.");
      return;
    }
    setCompareLoading(true);
    setError(null);
    setCompareResults([]);
    try {
      const results = await Promise.all(dests.map(async (dest) => {
        const response = await fetch("/api/claude", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            type: "analysis",
            body: {
              model: "claude-sonnet-4-5",
              max_tokens: 2000,
              messages: [{
                role: "user",
                content: `You are a travel advisor. Give a concise comparison summary for: ${dest}

Traveler type: ${travelers.join(", ") || "general"}, Budget: ${budget || "mid-range"}, Vibe: ${vibe.join(", ") || "general"}, Dates: ${dates || flexibility || "flexible"}.

## ${dest}
**Best For:** (1 line)
**Vibe:** (2-3 words)
**Walkability:** (score out of 10 and 1 sentence)
**Public Transit:** (1 sentence)
**Safety:** (1 sentence)
**Budget Fit:** (1 sentence)
**Top 3 Highlights:** (3 bullets)
**Book Ahead:** (2 bullets)
**Best Time to Go:** (1 sentence)
**Verdict:** (2 sentences on who this is perfect for)`,
              }],
            },
          }),
        });
        const data = await response.json();
        return { dest, text: data.content?.map(b => b.text || "").join("") || "" };
      }));
      setCompareResults(results);
    } catch (e) {
      setError("Comparison failed. Please try again.");
    } finally {
      setCompareLoading(false);
    }
  };

  const handleCopy = () => {
    if (!result) return;
    navigator.clipboard?.writeText(result);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  const handleClear = () => {
    setDestination(""); setOriginCountry(""); setDates(""); setFlexibility(""); setTravelers([]);
    setBudget(""); setVibe([]); setPriorities([]); setMustSee("");
    setPackingNeeds([]); setExtraNotes(""); setResult(null); setError(null);
  };

  const canSearch = destination.trim().length > 0;

  return (
    <div style={{ fontFamily: "var(--font-body)" }}>
      <style>{`
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: .4; } }
        .travel-tab { background: none; border: none; cursor: pointer; font-family: var(--font-body); font-size: 13px; font-weight: 600; padding: 10px 18px; border-radius: 50px; transition: all .15s; }
        .travel-tab.active { background: var(--accent); color: #fff; }
        .travel-tab:not(.active) { color: rgba(255,255,255,.6); }
        .travel-tab:not(.active):hover { background: rgba(255,255,255,.1); color: #fff; }
        .result-fade { animation: fadeInUp .35s ease; }
      `}</style>

      {/* ── Header ── */}
      <div style={{
        background: "linear-gradient(135deg, #1e1a2e 0%, #2d1b69 60%, #0f3460 100%)",
        padding: "36px 24px 32px", position: "relative", overflow: "hidden",
      }}>
        {[["10%","20%",60],["85%","60%",40],["50%","80%",80],["70%","15%",50]].map(([l,t,s], i) => (
          <div key={i} style={{ position: "absolute", width: s, height: s, borderRadius: "50%", background: "rgba(108,71,255,.15)", left: l, top: t, pointerEvents: "none" }} />
        ))}
        <div style={{ maxWidth: 860, margin: "0 auto", position: "relative" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 10, background: "rgba(108,71,255,.35)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon name="plane" size={17} color="#a78bff" />
            </div>
            <span style={{ fontSize: 10, fontWeight: 700, color: "#a78bff", letterSpacing: ".15em", textTransform: "uppercase" }}>
              AI Travel Planner
            </span>
          </div>
          <h1 style={{ fontSize: 26, fontWeight: 800, color: "#fff", fontFamily: "var(--font-display)", marginBottom: 8, lineHeight: 1.25 }}>
            Plan your next trip,<br /><span style={{ color: "#a78bff" }}>smarter.</span>
          </h1>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,.55)", maxWidth: 520, lineHeight: 1.65 }}>
            Get a complete travel guide — walkability, safety, transit, food, excursions, what to book ahead, and a custom packing list — matched to your style and budget.
          </p>
          <div style={{ display: "flex", gap: 6, marginTop: 22, background: "rgba(255,255,255,.08)", borderRadius: 50, padding: 4, width: "fit-content" }}>
            {[
              { id: "plan",    label: "✈️ Plan a Trip" },
              { id: "compare", label: "⚖️ Compare Trips" },
              { id: "saved",   label: `🗂️ Saved (${savedTrips.length})` },
            ].map(t => (
              <button key={t.id} onClick={() => setActiveTab(t.id)}
                className={`travel-tab${activeTab === t.id ? " active" : ""}`}>
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ── Body ── */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "28px 20px 80px" }}>

        {/* ─── SAVED ─── */}
        {activeTab === "saved" && (
          <div className="result-fade">
            {savedTrips.length === 0 ? (
              <div style={{ textAlign: "center", padding: "60px 20px" }}>
                <div style={{ fontSize: 44, marginBottom: 12 }}>🗂️</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: "var(--text)", marginBottom: 6 }}>No saved trips yet</div>
                <div style={{ fontSize: 13, color: "var(--muted)" }}>Plan a trip and hit "Save Trip" to keep it here.</div>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <div style={{ fontSize: 13, color: "var(--muted)", marginBottom: 4 }}>
                  {savedTrips.length} saved trip{savedTrips.length !== 1 ? "s" : ""}
                </div>
                {savedTrips.map(trip => (
                  <TripCard
                    key={trip.id}
                    trip={trip}
                    onRemove={() => setSavedTrips(prev => prev.filter(t => t.id !== trip.id))}
                    onView={() => {
                      setDestination(trip.destination);
                      setResult(trip.result);
                      setActiveTab("plan");
                      setTimeout(() => resultRef.current?.scrollIntoView({ behavior: "smooth" }), 200);
                    }}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {/* ─── COMPARE ─── */}
        {activeTab === "compare" && (
          <div className="result-fade">
            <div className="card">
              <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text)", marginBottom: 4 }}>Compare Destinations</div>
              <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 14 }}>
                Use <strong>Multi-City</strong> mode to add 2–4 destinations, or enter them separated by commas.
              </div>
              <LocationPicker onChange={setDestination} />

              <SLabel icon="users" label="Traveler Type" />
              <ChipSelect options={TRAVELER_OPTS} selected={travelers} onChange={setTravelers} />

              <SLabel icon="dollar" label="Budget" />
              <ChipSelect options={BUDGET_OPTS} selected={budget} onChange={setBudget} multi={false} />

              <SLabel icon="heart" label="Travel Vibe" />
              <ChipSelect options={VIBE_OPTS} selected={vibe} onChange={setVibe} />

              <SLabel icon="calendar" label="Trip Length" />
              <ChipSelect options={FLEX_OPTS} selected={flexibility} onChange={setFlexibility} multi={false} />

              <div style={{ marginTop: 20 }}>
                <button onClick={handleCompare} disabled={compareLoading || !destination.trim()} className="search-btn">
                  {compareLoading
                    ? <><Spinner /> Comparing...</>
                    : <><Icon name="globe" size={15} color="#fff" /> Compare Now</>}
                </button>
              </div>
            </div>

            {error && (
              <div style={{ background: "#fff0f0", border: "1.5px solid #fca5a5", borderRadius: 14, padding: "12px 16px", fontSize: 13, color: "#dc2626", marginTop: 16 }}>
                {error}
              </div>
            )}

            {compareResults.length > 0 && (
              <div style={{ marginTop: 24, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 16 }}>
                {compareResults.map(({ dest, text }) => (
                  <div key={dest} className="card result-fade" style={{ margin: 0 }}>
                    <div style={{ fontSize: 16, fontWeight: 800, color: "var(--accent)", marginBottom: 10, fontFamily: "var(--font-display)" }}>
                      {dest}
                    </div>
                    <AIResponse text={text} />
                    <button onClick={() => { setDestination(dest); setActiveTab("plan"); }} style={{
                      marginTop: 14, background: "var(--accent-soft)", color: "var(--accent)",
                      border: "1.5px solid var(--accent)", borderRadius: 50, padding: "8px 16px",
                      fontFamily: "var(--font-body)", fontSize: 12, fontWeight: 700, cursor: "pointer",
                    }}>
                      Plan Full Trip →
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ─── PLAN ─── */}
        {activeTab === "plan" && (
          <div className="result-fade">
            <div className="card">
              <div style={{ fontSize: 15, fontWeight: 700, color: "var(--text)", marginBottom: 2 }}>
                Where are you going?
              </div>
              <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 14 }}>
                Pick a location type, then enter your destination.
              </div>
              <LocationPicker onChange={setDestination} />

              <SLabel icon="plane" label="Where are you travelling from?" />
              <input
                className="txt-input"
                placeholder="Your home country (e.g. United States, Australia, UK…)"
                value={originCountry}
                onChange={e => setOriginCountry(e.target.value)}
                style={{ marginBottom: 4 }}
              />
              <div style={{ fontSize: 11, color: "var(--muted)", marginBottom: 2 }}>
                Used to tailor visa, passport, and entry requirement advice.
              </div>

              <SLabel icon="calendar" label="When are you going?" />
              <input
                className="txt-input"
                placeholder="Specific dates (e.g. Aug 10–17)"
                value={dates}
                onChange={e => setDates(e.target.value)}
                style={{ marginBottom: 10 }}
              />
              <ChipSelect options={FLEX_OPTS} selected={flexibility} onChange={setFlexibility} multi={false} />

              <SLabel icon="users" label="Who's going?" />
              <ChipSelect options={TRAVELER_OPTS} selected={travelers} onChange={setTravelers} />

              <SLabel icon="dollar" label="Budget" />
              <ChipSelect options={BUDGET_OPTS} selected={budget} onChange={setBudget} multi={false} />

              <SLabel icon="heart" label="Travel Vibe" />
              <ChipSelect options={VIBE_OPTS} selected={vibe} onChange={setVibe} />

              <SLabel icon="star" label="Top Priorities" />
              <ChipSelect options={PRIORITY_OPTS} selected={priorities} onChange={setPriorities} />

              <SLabel icon="bag" label="Packing Reminders" />
              <ChipSelect options={PACKING_OPTS} selected={packingNeeds} onChange={setPackingNeeds} />

              <SLabel icon="map" label="Must-See / Special Requests" />
              <input
                className="txt-input"
                placeholder="e.g. Mount Fuji, cooking class, halal food options…"
                value={mustSee}
                onChange={e => setMustSee(e.target.value)}
              />

              <SLabel icon="globe" label="Anything Else?" />
              <textarea
                className="txt-input"
                rows={2}
                placeholder="Mobility limitations, dietary needs, celebrating anniversary…"
                value={extraNotes}
                onChange={e => setExtraNotes(e.target.value)}
                style={{ resize: "vertical", minHeight: 64 }}
              />

              <div style={{ display: "flex", gap: 10, marginTop: 20, flexWrap: "wrap" }}>
                <button onClick={handleSearch} disabled={loading || !canSearch} className="search-btn">
                  {loading
                    ? <><Spinner /> Planning your trip...</>
                    : <><Icon name="sparkle" size={15} color="#fff" /> Plan My Trip</>}
                </button>
                {!loading && canSearch && (
                  <button onClick={handleClear} style={{
                    background: "var(--chip-bg)", color: "var(--muted)", border: "1.5px solid var(--border)",
                    borderRadius: 50, padding: "13px 20px", fontFamily: "var(--font-body)",
                    fontSize: 13, fontWeight: 600, cursor: "pointer",
                  }}>
                    Clear
                  </button>
                )}
              </div>
            </div>

            {error && (
              <div style={{ background: "#fff0f0", border: "1.5px solid #fca5a5", borderRadius: 14, padding: "12px 16px", fontSize: 13, color: "#dc2626", marginTop: 12 }}>
                {error}
              </div>
            )}

            {loading && (
              <div className="card" style={{ marginTop: 16 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
                  <div style={{ width: 28, height: 28, borderRadius: 8, background: "var(--accent)", display: "flex", alignItems: "center", justifyContent: "center", animation: "pulse 1.4s ease infinite" }}>
                    <Icon name="sparkle" size={14} color="#fff" />
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "var(--accent)" }}>
                    Researching {destination}…
                  </div>
                </div>
                {[90, 70, 80, 55, 75].map((w, i) => (
                  <div key={i} style={{ height: 12, background: "var(--border)", borderRadius: 6, width: w + "%", marginBottom: 10, animation: `pulse 1.4s ease ${i * 0.15}s infinite` }} />
                ))}
              </div>
            )}

            {result && !loading && (
              <div ref={resultRef} className="card result-fade" style={{ marginTop: 16 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 18, flexWrap: "wrap", gap: 10 }}>
                  <div>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "var(--text)", fontFamily: "var(--font-display)" }}>
                      ✈️ {destination}
                    </div>
                    <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 3 }}>
                      {[travelers.join(", "), budget, vibe.slice(0, 2).join(", ")].filter(Boolean).join(" · ")}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button onClick={handleCopy} style={{
                      display: "flex", alignItems: "center", gap: 6,
                      background: copied ? "#e8faf0" : "var(--chip-bg)",
                      border: "1.5px solid " + (copied ? "#1db96a" : "var(--border)"),
                      borderRadius: 50, padding: "7px 14px",
                      fontFamily: "var(--font-body)", fontSize: 11, fontWeight: 600,
                      color: copied ? "#1db96a" : "var(--muted)", cursor: "pointer",
                    }}>
                      <Icon name={copied ? "check" : "copy"} size={12} color={copied ? "#1db96a" : "var(--muted)"} />
                      {copied ? "Copied!" : "Copy"}
                    </button>
                    <button onClick={handleSaveTrip} style={{
                      display: "flex", alignItems: "center", gap: 6,
                      background: "var(--accent-soft)", color: "var(--accent)",
                      border: "1.5px solid var(--accent)", borderRadius: 50, padding: "7px 14px",
                      fontFamily: "var(--font-body)", fontSize: 11, fontWeight: 700, cursor: "pointer",
                    }}>
                      <Icon name="heart" size={12} color="var(--accent)" />
                      Save Trip
                    </button>
                  </div>
                </div>

                <div style={{ borderTop: "1.5px solid var(--border)", paddingTop: 16 }}>
                  <AIResponse text={result} />
                </div>

                <div style={{
                  marginTop: 28, padding: "18px 20px",
                  background: "linear-gradient(135deg, var(--accent-soft) 0%, #f0ebff 100%)",
                  borderRadius: 16, border: "1.5px solid var(--accent)",
                  display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap",
                }}>
                  <div style={{ width: 38, height: 38, borderRadius: 12, background: "var(--accent)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <Icon name="plane" size={18} color="#fff" />
                  </div>
                  <div style={{ flex: 1, minWidth: 180 }}>
                    <div style={{ fontSize: 13, fontWeight: 800, color: "var(--text)", marginBottom: 2 }}>
                      Thinking about relocating after this trip?
                    </div>
                    <div style={{ fontSize: 11, color: "var(--muted)" }}>
                      MoveMetrics Home Search finds real listings with filters for commute, schools, and lifestyle.
                    </div>
                  </div>
                  <button
                    onClick={() => { try { window.location.hash = "homes"; window.location.reload(); } catch (e) {} }}
                    style={{
                      background: "var(--accent)", color: "#fff", border: "none",
                      borderRadius: 50, padding: "9px 18px", fontFamily: "var(--font-body)",
                      fontSize: 12, fontWeight: 700, cursor: "pointer", flexShrink: 0,
                    }}
                  >
                    Search Homes
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
